import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector'; // <-- 1. Import the new module

i18n
  // Use the HttpApi backend to load translations
  .use(HttpApi)
  // --- 2. Add the browser language detector ---
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // The default language to use if no other language is detected
    fallbackLng: 'en',
    
    // Enable debugging in the console during development
    debug: process.env.NODE_ENV === 'development',

    // --- 3. Configure the language detector ---
    detection: {
      // Order and from where user language should be detected
      order: ['queryString', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      // Only detect languages that are in our supported list
      checkWhitelist: true, 
    },

    // Whitelist of supported languages
    supportedLngs: ['en', 'fr', 'de'],

    interpolation: {
      escapeValue: false, // React already protects from XSS
    },

    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
  });

export default i18n;